import { Component, ChangeDetectionStrategy } from '@angular/core';

import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { ChatService } from '../services';
import { AuthService, Unity4Claim } from '../../auth';
import { withLatestFrom } from 'rxjs/operators';

@Component({
  selector: 'lib-chat-user-list',
  templateUrl: './chat-user-list.component.html',
  styles: [
    `
      .small-text {
        font-size: 75%;
      }

      .bg-light {
        background-color: #e9edf2 !important;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChatUserListComponent {
  cancelTimeout: boolean;
  chatroomUsers$ = this.chatSvc.chatroomUsers$;
  currentUserId?: number;

  showToolTip$ = this.authSvc.hasClaim$(Unity4Claim.ChatSupervisor);

  constructor(private chatSvc: ChatService, private authSvc: AuthService) {
    this.cancelTimeout = false;
    this.authSvc.userId$.subscribe((uid) => {
      this.currentUserId = uid;
    });

    this.updateChatroomUserList();
  }

  cancel() {
    this.cancelTimeout = true;
  }

  confirmPersonalTooltip(userid: number) {
    if (userid !== this.currentUserId) {
      this.chatSvc.chatUserName$(userid).subscribe((uname) => {
        this.chatSvc
          .confirm(
            'Open Personal Chat',
            'Are you sure you wish to open a Personal Chat with ' + uname + '?'
          )
          .then((confirmresult) => {
            if (confirmresult) {
              this.cancelTimeout = true;
              this.chatSvc.showUserList(false);
              this.chatSvc.addPrivateChatroom(userid, this.currentUserId!);
            }
          });
      });
    }
  }

  hideUserList() {
    this.cancelTimeout = true;
    this.chatSvc.showUserList(false);
  }

  showTip(tip: NgbTooltip) {
    tip.open();
  }

  updateChatroomUserList() {
    this.chatSvc.activeRoom$
      .pipe(withLatestFrom(this.chatSvc.allchatroom$))
      .subscribe(([room, allchatroom]) => {
        if (room) {
          if (room === 'All Chat')
            this.chatSvc.requestChatroomUsers(allchatroom);
          else this.chatSvc.requestChatroomUsers(room);
        }
      });

    if (!this.cancelTimeout) {
      setTimeout(() => {
        this.updateChatroomUserList();
      }, 10000);
    }
  }
}
